import { createIcon } from "@chakra-ui/react";

export const CheckIcon = createIcon({
  viewBox: "0 0 17 12",
  d: "M0 5.82857L1.64571 4.11429L5.48571 7.2L14.8114 0L16.4571 1.71429L5.48571 12L0 5.82857Z",
});
